module.exports = __webpack_public_path__ + "static/media/rupee.0f118038.svg";